
const CartWalletPaymentMethodInput = {
  "name": "CartWalletPaymentMethodInput",
  "kind": "INPUT_OBJECT",
  "inputFieldBaseTypes": {
    "applePayWalletContent": "ApplePayWalletContentInput",
    "shopPayWalletContent": "ShopPayWalletContentInput"
  }
};
export default CartWalletPaymentMethodInput;